/**
 * 탈퇴 후 1년 재가입 차단 에러 식별 상수 및 판별 헬퍼
 */
export const DELETION_COOLDOWN_CODE = 'account_deletion_cooldown';

/**
 * 에러 객체 또는 메시지 문자열에서 탈퇴 후 1년 재가입 쿨다운 에러 여부를 안전하게 판별합니다.
 * - error.message, error.error_description, error.error, 또는 문자열 자체를 검사
 * - null/undefined/비문자열 입력 시 안전하게 false 반환
 * 
 * @param {any} errorOrMessage - Error 객체, Supabase Auth 에러, 문자열 또는 null/undefined
 * @returns {boolean} 차단 에러 여부
 */
export function isDeletionCooldownError(errorOrMessage) {
  if (!errorOrMessage) return false;

  if (typeof errorOrMessage === 'string') {
    return errorOrMessage.includes(DELETION_COOLDOWN_CODE);
  }

  const message = errorOrMessage.message || errorOrMessage.error_description || errorOrMessage.error;
  if (typeof message === 'string') {
    return message.includes(DELETION_COOLDOWN_CODE);
  }

  return false;
}
